import React, { Component } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import "./App.scss";
import "../styles/sharedStyles.scss";
import Nsc from "./pure/Nsc";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import Footer from "../shared/Footer/Footer";
import QuickStart from "../components/quickStart/QuickStart";
import ProgressBarTabs from "../components/progressBar/ProgressBarTabs";
import InvalidRoute from "../components/accessDenied/InvalidRoute";
import Reporting from "../components/reporting/Reporting";
import BusinessSettings from "../components/businessSetting/BusinessSettings";
import { logMsg } from "../common/Logger";
import withIdleTimer from "../common/WithIdleTimer";
import PricingWrapper from "../components/pricing/pricingWrapper/PricingWrapper";
import AccessDeniedNotOnboardedNsc from "../components/accessDenied/AccessDeniedNotOnboardedNsc";
import HasPermissionTo from "../common/HasPermissionTo";
import NscDashboard from "../components/dashboard/nscDashBoard/NscDashboard";
import NscCurrentPricing from "../components/pricing/pricingWrapper/currentPricing/NscCurrentPricing";
import NscFuturePricing from "../components/pricing/pricingWrapper/currentPricing/NscFuturePricing";
import NscOnboardingClient from "../shared/clients/NscOnboardingClient";
import LocalizedInfoClient from "../shared/clients/LocalizedInfoClient";
import ErrorScreen from "../errors/ErrorScreen";
import AccessoriesPricingWrapper from "../components/pricing/pricingWrapper/accessoriesPricing/AccessoriesPricingWrapper";
import { withTranslation } from "react-i18next";
import OrdersSearch from "../components/search/searchWrapper/orders/OrdersSearch";
import { IS_IRELAND_MARKET, IS_NETHERLAND_MARKET } from "../utils/EmpUtil";
import SearchWrapper from "../components/search/searchWrapper/SearchWrapper";
import DealerSearch from "../components/search/searchWrapper/dealer/DealerSearch";
import { MarketGroups } from "../shared/marketGroups/MarketGroups";
import ModifyReservationPrice from "../components/pricing/pricingWrapper/depositPricing/modifyReservationPrice/ModifyReservationPrice";
import EventAdministration from "../components/pricing/pricingWrapper/eventAdministration/EventAdministration";

class NSCApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      renderApp: false,
      shouldNavigationBeRestricted: false,
      padding: "70px",
      selectedMarket: "",
    };
    this.user = new Nsc(
      this.props.token,
      this.props.userDetails,
      this.props.history
    );
    this.localizedInfo = {};

    // Listening for route change
    this.props.history.listen(() => this.setNavigationRestriction());
    this.navigateToRoute = this.navigateToRoute.bind(this);
    this.onReservationSave = this.onReservationSave.bind(this);
  }

  componentDidMount() {
    this.setState({ selectedMarket: this.user.market }, () => {
      this.getLocalizedInfo();
    });
  }

  onReservationSave() {
    this.onBoardingStatus = "ACCEPTED";
    this.navigateToRoute("dashboard");
  }

  updateCurrentMarket = (market) => {
    this.setState({ selectedMarket: market }, () => {
      this.getLocalizedInfo();
    });
  };

  navigateToRoute(link) {
    this.props.history.push(`/${link}`);
  }

  setNavigationRestriction() {
    if (this.onBoardingStatus !== "ACCEPTED") {
      this.setState({ shouldNavigationBeRestricted: true });
    } else {
      const isAllowedPath = this.isCurrentPathAllowedToShowHeaderAndFooter(
        this.props.history.location.pathname
      );
      this.setState({ shouldNavigationBeRestricted: !isAllowedPath });
    }
  }

  setPadding = (padding) => {
    if (padding > 70) {
      this.setState({ padding: padding + "px" });
    }
  };

  isCurrentPathAllowedToShowHeaderAndFooter(currentPathName) {
    const staticAllowedPaths = [
      "/dashboard",
      "/pricing/event",
      "/pricing",
      "/pricing/vehicles",
      "/pricing/future",
      "/pricing/accessories",
      "/pricing/deposit",
      "/business-settings",
      "/reporting",
      "/search",
      "/search/orders",
      "/search/dealer",
      "/",
    ];

    return staticAllowedPaths.includes(currentPathName);
  }

  checkIsUserOnboarded() {
    this.isOnboarded()
      .then((val) => {
        this.onBoardingStatus = val.onboarded ? "ACCEPTED" : "PENDING";
        this.setNavigationRestriction();
      })
      .finally(() => {
        this.user.hasNscCompletedBasicPAs = true;
        this.setState({ renderApp: true });
      });
  }

  async isOnboarded() {
    //return await NscOnboardingClient.isOnboarded(this.user);
    return Promise.resolve({ onboarded: true });
  }

  getLocalizedInfo() {
    this.props.hideOrShow(true);
    LocalizedInfoClient.getLocalizedInfo(this.user, this.state.selectedMarket)
      .then((response) => {
        this.localizedInfo = Object.assign(
          {},
          { ...this.localizedInfo },
          { ...response }
        );
      })
      .catch((error) => logMsg("the error is: ", error))
      .finally(() => {
        //*** NSC screens are currently only in English
        if (IS_IRELAND_MARKET(this.state.selectedMarket)) {
          this.props.i18n.changeLanguage("en" + "_" + "IRL");
        } else if (IS_NETHERLAND_MARKET(this.state.selectedMarket)) {
          this.props.i18n.changeLanguage("en" + "_" + "NLD");
        } else {
          this.props.i18n.changeLanguage("en" + "_" + "GBR");
        }
        this.checkIsUserOnboarded();
        this.props.hideOrShow(false);
      });
  }

  getProgressBarTabs() {
    return ProgressBarTabs().onboardingNsc;
  }

  render() {
    const ProtectedRoute = ({
      component: Component,
      perform: perform,
      ...rest
    }) => (
      <HasPermissionTo
        perform={perform}
        permissions={this.user.permissions.rolePermissions}
        render={() => (
          <Route
            {...rest}
            render={() =>
              this.onBoardingStatus === "ACCEPTED" ? (
                <Component {...rest.customprops} {...this.props} />
              ) : (
                <Redirect to="/" />
              )
            }
          />
        )}
      />
    );
    return (
      this.state.renderApp && (
        <Router history={this.props.history}>
          <div className="appWrapper" id="appWrapper">
            {!this.state.shouldNavigationBeRestricted && (
              <div style={{ paddingTop: this.state.padding }}>
                <GlobalNavBar
                  {...this.props}
                  user={this.user}
                  urlPath={window.location.pathname}
                  navigateToRoute={this.navigateToRoute}
                  setPadding={this.setPadding}
                />
              </div>
            )}

            <Switch>
              <ProtectedRoute
                exact
                path="/pricing"
                component={withIdleTimer(PricingWrapper)}
                perform={["pricingPage"]}
                customprops={{
                  ...this.props,
                  user: this.user,
                  localizedInfo: this.localizedInfo,
                }}
              />
              <ProtectedRoute
                exact
                path="/dashboard"
                component={withIdleTimer(NscDashboard)}
                perform={["dashBoardPage"]}
                customprops={{
                  user: this.user,
                  groups: MarketGroups(this.user.market),
                  selectedMarket: this.state.selectedMarket,
                  updateCurrentMarket: this.updateCurrentMarket,
                }}
              />

              <ProtectedRoute
                exact
                path="/reporting"
                component={withIdleTimer(Reporting)}
                perform={["reportingPage"]}
                customprops={{
                  user: this.user,
                  groups: MarketGroups(this.user.market),
                  selectedMarket: this.state.selectedMarket,
                  updateCurrentMarket: this.updateCurrentMarket,
                }}
              />
              <ProtectedRoute
                exact
                path="/business-settings"
                component={withIdleTimer(BusinessSettings)}
                perform={["businessSettingsPage"]}
                customprops={{
                  ...this.props,
                  user: this.user,
                  localizedInfo: this.localizedInfo,
                  groups: MarketGroups(this.user.market),
                  selectedMarket: this.state.selectedMarket,
                  updateCurrentMarket: this.updateCurrentMarket,
                }}
              />
              <ProtectedRoute
                exact
                path="/pricing/event"
                component={withIdleTimer(() => (
                  <EventAdministration
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
                perform={["pricingAdministration"]}
              />
              <ProtectedRoute
                exact
                path="/pricing/vehicles"
                component={withIdleTimer(() => (
                  <NscCurrentPricing
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
                perform={["vehiclePricingTab"]}
              />
              <ProtectedRoute
                exact
                path="/pricing/future"
                component={withIdleTimer(() => (
                  <NscFuturePricing
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                  />
                ))}
                perform={["futurePricingTab"]}
              />
              <ProtectedRoute
                exact
                path="/pricing/accessories"
                perform={["accessoriesPricingTab"]}
                component={withIdleTimer(() => (
                  <AccessoriesPricingWrapper
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    groups={MarketGroups(this.user.market)}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
              />
              <ProtectedRoute
                exact
                path="/pricing/deposit"
                component={withIdleTimer(() => (
                  <ModifyReservationPrice
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
                perform={["depositPricingTab"]}
              />
              <ProtectedRoute
                exact
                path="/search"
                component={withIdleTimer(SearchWrapper)}
                perform={["searchLandingPage"]}
                customprops={{
                  user: this.user,
                  groups: MarketGroups(this.user.market),
                }}
              />
              <Route
                exact
                path="/search/orders"
                component={withIdleTimer(() => (
                  <OrdersSearch
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    groups={MarketGroups(this.user.market)}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
              />
              <Route
                exact
                path="/search/dealer"
                component={withIdleTimer(() => (
                  <DealerSearch
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.user}
                    groups={MarketGroups(this.user.market)}
                    selectedMarket={this.state.selectedMarket}
                    updateCurrentMarket={this.updateCurrentMarket}
                  />
                ))}
              />
              <Route
                exact
                path="/denied-nsc"
                component={AccessDeniedNotOnboardedNsc}
              />
              <Route
                exact
                path="/"
                render={() =>
                  this.onBoardingStatus === "ACCEPTED" ? (
                    <Redirect
                      to={{
                        pathname: "/dashboard",
                      }}
                    />
                  ) : (
                    <HasPermissionTo
                      perform={["quickStartPage"]}
                      permissions={this.user.permissions.rolePermissions}
                      render={() => (
                        <QuickStart
                          user={this.user}
                          {...this.props}
                          onboardingClient={NscOnboardingClient}
                          localizedInfo={this.localizedInfo}
                          onSave={this.onReservationSave}
                          progressBarTabs={this.getProgressBarTabs()}
                          fromQuickstart={true}
                        />
                      )}
                      noRender={() => (
                        <Redirect
                          to={{
                            pathname: "/denied-nsc",
                          }}
                        />
                      )}
                    />
                  )
                }
              />
              <Route
                exact
                path="/error"
                render={(props) => <ErrorScreen {...props} />}
              />
              <Route component={withIdleTimer(InvalidRoute)} />
            </Switch>
            {!this.state.shouldNavigationBeRestricted && (
              <Footer
                isDealer={false}
                fromNscDealerSearch={this.props.fromNscDealerSearch}
                footerTitle={this.props.t("Footer.title")}
                helpSupportTitle={this.props.t("Footer.help")}
                permissions={this.props.userDetails.permissions}
              />
            )}
          </div>
        </Router>
      )
    );
  }
}

export default withTranslation("emp")(NSCApp);
